import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  ManageSubDomesComponent,
  LayoutWrapperMain,
  Page,
} from '../../components';
import config from '../../config';
import './AddSubDomes.global.scss';

interface Props {
  scrollingDisabled: boolean,
  intl: any,
}

const ManageSubDomesPageComponent: React.FC<Props> = (props: Props) => {
  const {
    intl,
    scrollingDisabled,
  } = props;
  const { siteTitle } = config;
  const schemaTitle = intl.formatMessage(
    { id: 'SubDomesmanagement.page.title' },
    { siteTitle },
  );
  return (
    <Page
      title={schemaTitle}
      scrollingDisabled={scrollingDisabled}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: schemaTitle,
      }}
    >
      <LayoutWrapperMain className="layoutWrapperMain">
        <div className="content">
          <ManageSubDomesComponent />
        </div>
      </LayoutWrapperMain>
    </Page>
  );
};

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
  // submitSignup: (dispatch: any, data: any) => dispatch(Signup(data)),
});

const ManageSubDomes = compose(

  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
)(ManageSubDomesPageComponent);

export default ManageSubDomes;
